import styled from "@emotion/styled";
import {
  Box as MuiBox,
  Table as MuiTable,
  TableContainer as MuiTableContainer,
  TableRow as MuiTableRow,
} from "@mui/material";

export const BoxTable = styled(MuiBox)({
  height: "100%",
});

export const AppTableContainer = styled(MuiTableContainer)({
  borderRadius: 0,
  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  boxShadow: "none",
  height: "calc(100% - 52px)",
  overflowX: "auto",
});

export const AppTableRoot = styled(MuiTable)({
  maxHeight: "100%",
});

export const AppTableRow = styled(MuiTableRow)({
  "&:last-child td, &:last-child th": { border: 0 },
});
